// extracted by mini-css-extract-plugin
module.exports = {"root":"Preview_root__3CCBF","imgContainer":"Preview_imgContainer__3zFVM"};